import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.04 3.2399C5.09026 2.18964 6.51471 1.59961 8 1.59961C9.48529 1.59961 10.9097 2.18964 11.96 3.2399C13.0103 4.29015 13.6003 5.71461 13.6003 7.19989C13.6003 8.68518 13.0103 10.1096 11.96 11.1599L8 15.1199L4.04 11.1599C3.51993 10.6399 3.10739 10.0225 2.82593 9.34305C2.54446 8.66359 2.3996 7.93535 2.3996 7.19989C2.3996 6.46444 2.54446 5.7362 2.82593 5.05674C3.10739 4.37728 3.51993 3.75991 4.04 3.2399ZM8 8.79989C8.42435 8.79989 8.83131 8.63132 9.13137 8.33126C9.43143 8.03121 9.6 7.62424 9.6 7.19989C9.6 6.77555 9.43143 6.36858 9.13137 6.06852C8.83131 5.76847 8.42435 5.5999 8 5.5999C7.57565 5.5999 7.16869 5.76847 6.86863 6.06852C6.56857 6.36858 6.4 6.77555 6.4 7.19989C6.4 7.62424 6.56857 8.03121 6.86863 8.33126C7.16869 8.63132 7.57565 8.79989 8 8.79989Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}